import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface TabItem {
  id: string;
  name: string;
  icon?: ReactNode;
}

interface TabsProps {
  items: TabItem[];
  activeItem: number;
  onItemClick: ( index: number ) => void;
}

const Tabs: React.FC<TabsProps> = ( { items, activeItem, onItemClick } ) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap font-comfortaa font-bold mt-3 relative">
      {items.length > 0 ? (
        items.map( ( item, index ) => {return (
          <div
            key={item.id}
            className="cursor-pointer hover:bg-white rounded-md trans-fast"
            onClick={() => {return onItemClick( index );}}
          >
            { item.icon }
            <h2 className="mx-8 h-9 py-2 w-max max-w-72 truncate">{item.name}</h2>
            <hr
              className={`border-none rounded-full w-full h-[3px] trans-fast shadow ${
                activeItem === index ? 'bg-app-color-light' : 'bg-white'
              }`}
            />
          </div>
        );} )
      ) : (
        <div className="w-full text-gray-base-dark flex justify-center flex-col items-center">
          <h2 className="mx-8 h-9 w-max">{ t( 'common:no_items' ) }</h2>
          <hr className="border-none rounded-full w-full h-[3px] trans-fast shadow bg-white" />
        </div>
      )}
    </div>
  );
};

export default Tabs;
